export const getters = {
  getModalViewUnilevel: state => state.modalViewUnilevel,
  getUnilevels: state => state.unilevels,
  getUnilevel: state => state.unilevel
};

export default {};
